import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ProductModule = lazy(loadModule);

export default ProductModule;
